import React from 'react';
import PropTypes from 'prop-types';
import {
  Column,
  Grid,
  Row,
  Text,
  StatusAlert,
  Spacing,
  Button
} from '@dls/web';
import { trans as t } from '../../helpers/localisation';

const CisError = props => {
  const { title, subTitle, ctaText, ctaUrl } = props;

  return (
    <Grid>
      <Row>
        <Column>
          <Text type="bannerTitle">{t('CIS_ERROR_TITLE')}</Text>
          <Spacing topBottom={5}>
            <StatusAlert
              bodyContent={
                <>
                  <Text type="smallBody">{subTitle}</Text>
                  {ctaText && ctaUrl && (
                    <Spacing top={2} responsive={false}>
                      <Button
                        type="primary"
                        onClick={() => {
                          ctaUrl && window.open(ctaUrl);
                        }}
                        text={ctaText}
                      />
                    </Spacing>
                  )}
                </>
              }
              title={title}
              type="alert"
            />
          </Spacing>
        </Column>
      </Row>
    </Grid>
  );
};

CisError.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  subTitle: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string
};

export default CisError;
